<template>
  <qd-message :title="$t(title)"
             :closable="canClose"
             type="is-danger"
             :class="{
               'error-msg-component': fixeHeigth
             }"
             class="is-preLine"
             v-if="error"
             @close="$emit('close', false)">
    {{$t(titreMessageErreurEcran)}}
    <div v-if="!withEmplyFields">
      <li v-for="(msg, $index) in messages"
          :key="$index">
          <span v-if="msg.preMessage">
            {{$t(
              msg.preMessage.message,
              msg.preMessage.parametres ? msg.preMessage.parametres : {})
            }}
          </span>
          <span>
            {{$t(msg.message, msg.parametres ? msg.parametres : {})}}
          </span>
      </li>
    </div>
    <div v-else>
      <ul>
        <li v-for="(msg, $index) in messages"
            :key="$index">
          <span v-if="msg.preMessage">
            {{$t(
              msg.preMessage.message,
              msg.preMessage.parametres ? msg.preMessage.parametres : {})
            }}
          </span>
          <span>
            {{$t(msg.message, msg.parametres ? msg.parametres : {})}}
          </span>
        </li>
      </ul>
      <div v-if="messagesChampsVide[0]">
        <ul>
          <li>
            {{$t(messagesChampsVide[0])}}
          </li>
        </ul>
        <li v-for="(message, $index) in champsVide"
            :key="$index">
          {{$t(message)}}
        </li>
      </div>
    </div>
  </qd-message>
</template>

<script>
export default {
  props: {
    messages: {
      type: Array,
      default() {
        return [];
      },
    },
    error: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    withEmplyFields: {
      type: Boolean,
      default: false,
    },
    messagesChampsVide: {
      type: Array,
      default() {
        return [];
      },
    },
    champsVide: {
      type: Array,
      default() {
        return [];
      },
    },
    titreMessageErreurEcran: {
      type: String,
      default: '',
    },
    canClose: {
      type: Boolean,
      required: false,
      default: true,
    },
    fixeHeigth: {
      type: Boolean,
      defaul: false,
    },
  },
};
</script>

<style>

</style>
